
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: '김민수',
      position: 'CEO, 테크스타트업',
      company: '이노베이션랩',
      content: 'FunnelMaster 덕분에 마케팅 전환율이 300% 향상되었습니다. AI가 생성한 퍼널이 정말 놀라울 정도로 정확했어요.',
      rating: 5,
      avatar: 'https://public.readdy.ai/ai/img_res/994df84244291a0a52eeb302565cf7d3.jpg'
    },
    {
      name: '박지영',
      position: '마케팅 디렉터',
      company: '글로벌커머스',
      content: '복잡한 마케팅 퍼널을 5분 만에 완성할 수 있다니 믿을 수 없었습니다. 이제 전략 수립에 더 많은 시간을 투자할 수 있어요.',
      rating: 5,
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Korean%20businesswoman%20in%20her%2030s%2C%20friendly%20smile%2C%20modern%20office%20setting%2C%20business%20attire%2C%20confident%20professional%20headshot%2C%20high%20quality%20portrait&width=100&height=100&seq=avatar2&orientation=squarish'
    },
    {
      name: '이준호',
      position: '온라인 마케터',
      company: '디지털에이전시',
      content: '클라이언트마다 다른 퍼널을 만들어야 했는데, FunnelMaster로 업무 효율성이 크게 개선되었습니다. 정말 혁신적인 도구예요.',
      rating: 5,
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Korean%20professional%20man%20in%20his%20late%2020s%2C%20creative%20marketing%20professional%2C%20casual%20business%20attire%2C%20modern%20workspace%20background%2C%20friendly%20professional%20headshot&width=100&height=100&seq=avatar3&orientation=squarish'
    },
    {
      name: '최수진',
      position: '창업자',
      company: '뷰티브랜드',
      content: '마케팅 경험이 없었는데도 전문가 수준의 퍼널을 만들 수 있었습니다. 매출이 2배 이상 증가했어요!',
      rating: 5,
      avatar: 'https://readdy.ai/api/search-image?query=Korean%20female%20entrepreneur%20in%20her%20early%2030s%2C%20beauty%20industry%20professional%2C%20elegant%20business%20style%2C%20confident%20smile%2C%20modern%20office%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar4&orientation=squarish'
    },
    {
      name: '정태현',
      position: 'CMO',
      company: '핀테크기업',
      content: 'A/B 테스트 자동화 기능이 특히 인상적입니다. 데이터 기반의 의사결정을 더 빠르게 내릴 수 있게 되었어요.',
      rating: 5,
      avatar: 'https://readdy.ai/api/search-image?query=Senior%20Korean%20business%20executive%20in%20his%2040s%2C%20fintech%20industry%20professional%2C%20sophisticated%20business%20suit%2C%20executive%20office%20background%2C%20authoritative%20professional%20headshot&width=100&height=100&seq=avatar5&orientation=squarish'
    },
    {
      name: '한소영',
      position: '마케팅 매니저',
      company: '교육기업',
      content: '교육 업계 특성에 맞는 퍼널을 정확히 생성해줘서 놀랐습니다. 학습자 전환율이 크게 향상되었어요.',
      rating: 5,
      avatar: 'https://readdy.ai/api/search-image?query=Korean%20female%20marketing%20professional%20in%20her%20late%2020s%2C%20education%20industry%2C%20smart%20casual%20attire%2C%20modern%20educational%20environment%20background%2C%20friendly%20professional%20headshot&width=100&height=100&seq=avatar6&orientation=squarish'
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            고객들의 성공 스토리
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            다양한 업종의 고객들이 FunnelMaster로 어떤 성과를 거두었는지 확인해보세요
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-4">
                <img 
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.position}</p>
                  <p className="text-sm text-teal-600">{testimonial.company}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
              
              <p className="text-gray-700 leading-relaxed">"{testimonial.content}"</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-teal-50 rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              당신도 성공 스토리의 주인공이 되어보세요
            </h3>
            <p className="text-gray-600 mb-6">
              수천 명의 마케터들이 이미 FunnelMaster로 놀라운 결과를 만들어내고 있습니다
            </p>
            <button className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer">
              무료로 시작하기
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
